import Toggle from "react-toggle";

const Status = (props) => {
  return <Toggle disabled id="cheese-status" checked={props.status} />;
};

export default Status;
